"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _recharts = require("recharts");

var _CustomRechartsTooltipContent = _interopRequireDefault(require("./CustomRechartsTooltipContent"));

var _providers = require("../../toolkit/providers");

var _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CustomTooltip = function CustomTooltip(props) {
  // we render the default, but with our overridden style
  var contentStyle = props.contentStyle;

  var _useTheming = (0, _providers.useTheming)(),
      fonts = _useTheming.fonts;

  return /*#__PURE__*/_react["default"].createElement(_CustomRechartsTooltipContent["default"], (0, _extends2["default"])({}, props, {
    cursor: false,
    labelFormatter: function labelFormatter() {
      return " ";
    },
    hasSeparator: false,
    contentStyle: _objectSpread(_objectSpread({}, contentStyle), {}, {
      fontFamily: "".concat(fonts.medium, ", 'Helvetica Neue', Helvetica, Arial, sans-serif"),
      fontSize: "12px",
      fontStyle: "normal",
      fontStretch: "normal",
      letterSpacing: "normal",
      textAlign: "left"
    })
  }));
};

var RechartsTooltip = (0, _mobxReact.observer)(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(RechartsTooltip, _Component);

  var _super = _createSuper(RechartsTooltip);

  function RechartsTooltip() {
    (0, _classCallCheck2["default"])(this, RechartsTooltip);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(RechartsTooltip, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_recharts.Tooltip, this.props);
    }
  }]);
  return RechartsTooltip;
}(_react.Component), _class2.propDoc = {
  imageFormatter: {
    required: false,
    type: "(name: string | number) => any",
    description: "display image in legend by displaying icon for a datakey"
  },
  formatter: {
    required: false,
    type: "(value: string | number, name: string | number, entry: any, " + "i: number) => any",
    description: "format value for datakey (name)"
  },
  content: {
    required: false,
    type: "ReactNode | ((props: RechartsTooltipProps) => ReactNode)",
    description: "custom content for tooltip (i.e CustomTooltipContent)"
  }
}, _class2.defaultProps = {
  content: /*#__PURE__*/_react["default"].createElement(CustomTooltip, {
    imageFormatter: function imageFormatter() {
      return null;
    }
  })
}, _temp)) || _class;

var _default = RechartsTooltip;
exports["default"] = _default;